module.exports = __webpack_public_path__ + "img/img_jp1.047256d1.jpg";